import { SET_SUBSCRIPTION_CURRENCY_ACTION_TYPE } from '../constants';

export const setSubscriptionCurrency = (currency: string) => ({
  type: SET_SUBSCRIPTION_CURRENCY_ACTION_TYPE,
  payload: currency
});
